import React, { useState } from "react";
import { Table, Label } from "semantic-ui-react";
import dayjs from "dayjs";
import numeral from "numeral";

const PaystackDetails = (props) => {
  const [item] = useState(props?.receipt);


  return (
    <div>
      <Table celled>
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell>Payment Reference</Table.HeaderCell>
            <Table.Cell>{item?.reference}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.HeaderCell>Payment Status</Table.HeaderCell>
            <Table.Cell>
              <Label
                color={
                  item.status === "success"
                    ? "green"
                    : item.status === ""
                      ? "violet"
                      : "brown"
                }
              >
                {item.status}
              </Label>
            </Table.Cell>
          </Table.Row>



          <Table.Row>
            <Table.HeaderCell>Customer Email</Table.HeaderCell>
            <Table.Cell>{item?.customer?.email}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.HeaderCell>Amount</Table.HeaderCell>
            <Table.Cell>₦{numeral((item.amount / 100)).format("0,0")}</Table.Cell>
          </Table.Row>

          <Table.Row>
            <Table.HeaderCell>Currency</Table.HeaderCell>
            <Table.Cell>{item?.currency}</Table.Cell>
          </Table.Row>

          {item.createdAt && (
            <Table.Row>
              <Table.HeaderCell>Check In</Table.HeaderCell>
              <Table.Cell>
                {dayjs(item?.createdAt).format("DD/MM/YYYY")}
              </Table.Cell>
            </Table.Row>
          )}

           
       <>
              <Table.Row>
                <Table.HeaderCell>Payout Amount</Table.HeaderCell>
                <Table.Cell>

                ₦{
                       props?.payout?.map((payout) => {
                       return payout?.reference.includes(item?.reference) ? 
                       numeral((payout?.amount / 100)).format("0,0.00") +  `---Batch Id#${payout?.Batch_id}`: false
                    })
                        
                  }

                </Table.Cell>
              </Table.Row>

            </>
          

        </Table.Body>
      </Table>
    </div>
  );
};

export default PaystackDetails;
